/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export class GetProfile {
  static readonly type = '[address-widget] get profile'
}

export class GetAddresses {
  static readonly type = '[address-widget] get addresses'
}

export class SelectAddress {
  static readonly type = '[address-list] select addresses'

  constructor(
    public selectedAddressId: string,
    public instanceId: string,
  ) {}
}

export class SetAddressBeingEdited {
  static readonly type = '[address-form] set address being edited'

  constructor(
    public addressIdBeingEdited: string,
    public instanceId: string,
  ) {}
}

export class SetAddressListDisabled {
  static readonly type = '[address-list] set disabled address list'

  constructor(
    public disabled: boolean,
    public instanceId: string,
  ) {}
}

export class SetAddressListOverlayLoadingStatus {
  static readonly type = '[address-list] set address list overlay loading status'

  constructor(public loading: boolean) {}
}
